import { render, staticRenderFns } from "./VerificationBDDForm.vue?vue&type=template&id=81e78164&"
import script from "./VerificationBDDForm.vue?vue&type=script&lang=js&"
export * from "./VerificationBDDForm.vue?vue&type=script&lang=js&"
import style0 from "./VerificationBDDForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports